import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const RoutePictogram = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path transform="scale(-1, 1) translate(-16, 0)" d="M12.6667 11.2C13.9554 11.2 15 12.2745 15 13.6C15 14.9255 13.9554 16 12.6667 16C11.378 16 10.3333 14.9255 10.3333 13.6C10.3333 12.2745 11.378 11.2 12.6667 11.2ZM10.7222 1.6C12.6552 1.6 14.2222 3.21178 14.2222 5.2C14.2222 7.18824 12.6552 8.8 10.7222 8.8H5.27778C4.20389 8.8 3.33333 9.69544 3.33333 10.8C3.33333 11.9046 4.20389 12.8 5.27778 12.8H8.77778C9.20734 12.8 9.55556 13.1582 9.55556 13.6C9.55556 14.0418 9.20734 14.4 8.77778 14.4H5.27778C3.34478 14.4 1.77778 12.7882 1.77778 10.8C1.77778 8.81176 3.34478 7.2 5.27778 7.2H10.7222C11.7961 7.2 12.6667 6.30457 12.6667 5.2C12.6667 4.09543 11.7961 3.2 10.7222 3.2H7.22222C6.79266 3.2 6.44444 2.84182 6.44444 2.4C6.44444 1.95818 6.79266 1.6 7.22222 1.6H10.7222ZM3.33333 0C4.62199 0 5.66667 1.07452 5.66667 2.4C5.66667 3.72548 4.62199 4.8 3.33333 4.8C2.04467 4.8 1 3.72548 1 2.4C1 1.07452 2.04467 0 3.33333 0Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { RoutePictogram };